const state = {
  errorMessage: "",
  layout: "default"
};

const getters = {
  getErrorMessage(state) {
    return state.errorMessage;
  },
  layout(state) {
    return state.layout;
  }
};

const actions = {
  setErrorMessage({ commit }, error) {
    commit("changeErrorMessage", error);
  },
  setLayout({ state }, layout) {
    state.layout = layout;
  }
};

const mutations = {
  changeErrorMessage(state, error) {
    state.errorMessage = error;
  },
  deleteErrorMessage(state) {
    state.errorMessage = "";
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
